"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInfectiousDiseaseTestDto = instanceOfInfectiousDiseaseTestDto;
exports.InfectiousDiseaseTestDtoFromJSON = InfectiousDiseaseTestDtoFromJSON;
exports.InfectiousDiseaseTestDtoFromJSONTyped = InfectiousDiseaseTestDtoFromJSONTyped;
exports.InfectiousDiseaseTestDtoToJSON = InfectiousDiseaseTestDtoToJSON;
exports.InfectiousDiseaseTestDtoToJSONTyped = InfectiousDiseaseTestDtoToJSONTyped;
const FileDto_1 = require("./FileDto");
const InfectiousDiseaseTestType_1 = require("./InfectiousDiseaseTestType");
/**
 * Check if a given object implements the InfectiousDiseaseTestDto interface.
 */
function instanceOfInfectiousDiseaseTestDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('testDate' in value) || value['testDate'] === undefined)
        return false;
    return true;
}
function InfectiousDiseaseTestDtoFromJSON(json) {
    return InfectiousDiseaseTestDtoFromJSONTyped(json, false);
}
function InfectiousDiseaseTestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'code': (0, InfectiousDiseaseTestType_1.InfectiousDiseaseTestTypeFromJSON)(json['code']),
        'testDate': (new Date(json['testDate'])),
        'isTestDateValid': json['isTestDateValid'] == null ? undefined : json['isTestDateValid'],
        'testCard': json['testCard'] == null ? undefined : json['testCard'],
        'testCardV2': json['testCardV2'] == null ? undefined : (0, FileDto_1.FileDtoFromJSON)(json['testCardV2']),
    };
}
function InfectiousDiseaseTestDtoToJSON(json) {
    return InfectiousDiseaseTestDtoToJSONTyped(json, false);
}
function InfectiousDiseaseTestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'code': (0, InfectiousDiseaseTestType_1.InfectiousDiseaseTestTypeToJSON)(value['code']),
        'testDate': ((value['testDate']).toISOString()),
        'isTestDateValid': value['isTestDateValid'],
        'testCard': value['testCard'],
        'testCardV2': (0, FileDto_1.FileDtoToJSON)(value['testCardV2']),
    };
}
//# sourceMappingURL=InfectiousDiseaseTestDto.js.map